import { render } from "./Signin.vue?vue&type=template&id=55dffd5f&scoped=true"
import script from "./Signin.vue?vue&type=script&lang=js"
export * from "./Signin.vue?vue&type=script&lang=js"

import "./Signin.vue?vue&type=style&index=0&id=55dffd5f&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dffd5f"]])

export default __exports__